import { FormLabel } from '@src/components/ui';
import { ICommonFormProps } from '../DynamicForm.types';
import { Radio } from 'antd';
import { isFormValidationError } from '@src/utilities/form';
import styled from 'styled-components';

export const StyledRadioGroup = styled(Radio.Group)`
    .ant-radio-label {
        font-weight: 400;
        font-size: 16px;
        color: var(--color-text) !important;
    }
    .ant-radio-inner {
        width: 24px;
        height: 24px;
        border: 2px solid var(--color-divider);
        background-color: var(--color-surface);
        transition: all 0.3s ease;
    }

    .ant-radio-inner::after {
        display: block;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        content: '';
        border: 2px solid var(--color-divider);
        transition: all 0.3s ease;
    }

    .ant-radio-checked .ant-radio-inner {
        background-color: var(--color-primary);
        border-color: var(--color-primary);
    }

    .ant-radio-checked .ant-radio-inner::after {
        background-color: var(--color-primary);
        transform: scale(1);
    }
    .ant-radio-checked + .ant-radio-label {
        color: var(--color-primary);
    }

    .ant-radio-disabled .ant-radio-inner {
        border-color: var(--color-divider) !important;
        background-color: var(--color-surface);
    }

    .ant-radio-disabled + .ant-radio-label {
        color: var(--color-text);
    }
`;

export function FormRadioGroup(props: Readonly<ICommonFormProps>) {
    const { label } = props;

    const onChange = (e: any) => {
        if (props.field) {
            const value = e?.target?.value ?? e?.currentTarget?.value;
            if (value !== undefined) {
                props.field.onChange(value);
            }
        }
    };

    return (
        <div className="flex flex-col gap-2.5">
            {label && (
                <FormLabel
                    label={label}
                    required={props.registerOptions?.required as boolean}
                />
            )}

            {props.formProps?.secondLabel && (
                <p className="text-primary text-base">
                    {props.formProps?.secondLabel}
                </p>
            )}

            <StyledRadioGroup
                name={props.keyName}
                options={props.formProps?.options ?? []}
                value={props.field?.value ?? props.formProps?.defaultValue}
                onChange={onChange}
                disabled={props.disabled}
                className={props.className}
                defaultValue={props.formProps?.defaultValue}
            />

            {props.errors && (
                <span className="w-full font-normal text-xs text-left mt-1 text-error">
                    {isFormValidationError(props.errors.type)
                        ? props.errors?.message
                        : `${props.label} ${props.errors.type}`}
                </span>
            )}
        </div>
    );
}
